exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".w7s_Wlf-X912QziEOdPzM{width:100%;color:\"[theme:neutralSecondary, default:#605e5c]\"}._1OquM-n38tFg8qiOD71tIW{font-size:14px;height:25px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);
// Exports
exports.locals = {
	"weekNumber": "w7s_Wlf-X912QziEOdPzM",
	"weekNumberString": "_1OquM-n38tFg8qiOD71tIW"
};